export default class ClientCarousel {
    static init() {
        document.addEventListener('clients:slideDown', () => {
            document.querySelector('.clients').classList.remove('appear-anim-block');
            setTimeout(() => Livewire.emit('clients:refresh'), 1200);
        });
        document.addEventListener('clients:slideUp',
            () => document.querySelector('.clients').classList.add('appear-anim-block'));
    }
}
